import AxiosInstanceCreator from 'services/api';
import { BaseApiResponse } from '../../common';
import { CctvResponse, GasDetectorResponse, HookResponse } from '../models/maps.model.ts';

const device = '/device';

const deviceInstance = new AxiosInstanceCreator().create();

export const deviceApi = {
  async getCctvList(): Promise<BaseApiResponse<unknown, CctvResponse>> {
    const response = await deviceInstance.get(`${device}/cctv`);
    return response.data;
  },

  async getCctvListForZone(): Promise<BaseApiResponse<unknown, CctvResponse>> {
    const response = await deviceInstance.get(`${device}/cctv-for-zone`);
    return response.data;
  },

  async getGasDetectorList(): Promise<BaseApiResponse<unknown, GasDetectorResponse>> {
    const response = await deviceInstance.get(`${device}/gas-detector`);

    return response.data;
  },

  async getHookList(): Promise<BaseApiResponse<unknown, HookResponse>> {
    const response = await deviceInstance.get(`${device}/hook`);

    return response.data;
  },

  async findIotDeviceList(ptwNo: any): Promise<BaseApiResponse<unknown, HookResponse>> {
    const response = await deviceInstance.get(`${device}/find-iot-device?ptwNo=${ptwNo}`);
    return response.data;
  }
};
